module.exports = __webpack_public_path__ + "img/shelf_n.e6e1b48e.png";